// Packages
import cx from 'classnames';
// Components
import Icon, { IconName } from 'components/lib/Icon';
// Styles
import styles from './notificationIcons.module.scss';

type TNotificationType = 'success' | 'info' | 'error' | 'warning';

const NOTIFICATION_ICON: Record<TNotificationType, IconName> = {
  success: 'circle-check',
  info: 'info',
  error: 'circle-x',
  warning: 'circle-alert',
};

const NOTIFICATION_ICON_SIZE = 24;

// antd tints its own type icons through a class on the icon; a custom `icon` gets none, so the
// colour comes from ours.
export const getNotificationIcon = (type: TNotificationType) => (
  <Icon
    name={NOTIFICATION_ICON[type]}
    size={NOTIFICATION_ICON_SIZE}
    className={cx(styles.icon, styles[type])}
  />
);
